import { Snackbar, Alert } from '@mui/material'

import { useAppDispatch, useAppSelector } from '@/app/hooks'
import { clearNotification } from '@/app/notificationSlice'

export function GlobalNotification() {
    const dispatch = useAppDispatch()
    const notification = useAppSelector(state => state.notification.current)

    const handleClose = () => {
        dispatch(clearNotification())
    }

    return (
        <Snackbar
            open={!!notification}
            autoHideDuration={6000}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
            {notification ? (
                <Alert onClose={handleClose} severity={notification.severity} variant="filled">
                    {notification.message}
                </Alert>
            ) : undefined}
        </Snackbar>
    )
}
